<template>
  <div class="flex items-center">
    <template v-if="params.data.type_service === 'Inmigration'">
      <!-- <vs-avatar :src="correctedPath(params.data.avatar_client)" title="Ver Detalles" class="flex-shrink-0 mr-2" size="30px" @click="toClientPerfil(params.data)" /> -->
      <p @click="toClientPerfil(params.data)" class="text-inherit hover:text-primary cursor-pointer" title="Ver Detalles" >{{ params.data.full_name_client }}</p>
      <feather-icon title="Servicio Desactivado" icon="AlertCircleIcon" svgClasses="h-5 w-5 mr-4 text-warning hover:text-primary cursor-pointer" v-if="params.data.flag_active_plan_added_service === 0" />
    </template>
    <template v-else>
      <!-- <vs-avatar :src="correctedPath(params.data.avatar_profile_image_user)" title="Ver Detalles" class="flex-shrink-0 mr-2" size="30px" @click="toClientPerfil(params.data)" /> -->
      <p @click="toClientPerfil(params.data)" class="text-inherit hover:text-primary cursor-pointer" title="Ver Detalles">{{ params.data.names_client }} {{ params.data.surnames_client }}</p>
      <feather-icon title="Email no verificado" icon="MailIcon" svgClasses="h-5 w-5 mr-4 text-warning hover:text-primary cursor-pointer" v-if="params.data.verified_email_user == 0" />
    </template>
    
  </div>
</template>

<script>
import axios from '@/axios.js'
export default {
  name: 'CellRendererLink',
  methods: {
    correctedPath (avatar) {
      if (avatar === null) return 
      return (axios.defaults.baseURLnoAPI) + avatar
    },
    toClientPerfil (data) {
      return this.$router.push({name:'admin.cliente', params: {id_client: data.id_client}}).catch((error) => console.log(error))
    }
  }
}
</script>
